import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef, memo } from 'react';
import { Transition } from 'react-transition-group';
import styled from '@emotion/styled';
import { Card } from '../card/card';
import { Button, ButtonRow } from '../buttons';
import { transitionStyles, transitionTimeouts } from './incoming_call_notification_transition';
import { AppIcon } from '../icons';
import theme from '../../styles/theme';
import { CompanyWatermark } from '../watermark';
import { Column, Row } from '../layout';
import { AppText, Header, Subheader } from '../typography';
import { Theme } from '../../styles';
const _IncomingCallNotification = ({ open, onAnswer, onDecline, onEnter, onExit, shouldDisableButtons, customerName = 'Customer', brandName = 'Streem', brandLogoUrl = null, brandPrimaryColor, }) => {
    const nodeRef = useRef(null);
    return (_jsx(Transition, { in: open, nodeRef: nodeRef, appear: true, exit: true, unmountOnExit: true, timeout: transitionTimeouts, onEnter: onEnter, onExit: onExit, children: (state) => (_jsx(CallNotificationCard, { state: state, decoratorPosition: "top", shadow: "xlarge", "data-testid": "incoming-call-notification", animated: true, decoratorColor: brandPrimaryColor, children: _jsxs(Row, { justifyContent: "space-between", alignItems: "center", style: { width: '100%' }, children: [_jsxs(Column, { children: [_jsx(CallNotificationHeader, { brandName: brandName, brandLogoUrl: brandLogoUrl }), _jsx(CallNotificationSubheader, { customerName: customerName })] }), _jsx(CallNotificationButtons, { disabled: shouldDisableButtons, handleAnswer: onAnswer, handleDecline: onDecline })] }) })) }));
};
const CallNotificationHeader = ({ brandName, brandLogoUrl }) => {
    return (_jsxs(Row, { alignItems: "center", style: { marginBottom: '1.25rem' }, children: [brandLogoUrl && (_jsx(CallNotificationLogo, { brandLogoUrl: brandLogoUrl, "data-testid": "call-notification-brand-logo" })), _jsxs(Header, { "data-testid": "call-notification-brand-name", size: "xxlarge", style: { marginLeft: brandLogoUrl ? '1rem' : '', padding: '0.1875rem 0' }, children: ["Incoming ", brandName, " Video Chat"] })] }));
};
const CallNotificationLogo = ({ brandLogoUrl }) => {
    const handleLogoError = (event) => (event.target.style.display = 'none');
    return _jsx(CompanyWatermark, { src: brandLogoUrl, onError: handleLogoError });
};
const CallNotificationSubheader = ({ customerName }) => {
    return (_jsxs(Column, { children: [_jsx(AppText, { semibold: true, headingFontFamily: true, size: "mediumLarge", style: { color: Theme.colors.grey50 }, children: "Call From" }), _jsx(Subheader, { headingFontFamily: true, style: { fontWeight: 700 }, "data-testid": "call-notification-customer-name", "data-clarity-mask": "true", children: customerName })] }));
};
const CallNotificationButtons = ({ disabled, handleAnswer, handleDecline }) => {
    return (_jsxs(ButtonRow, { children: [_jsxs(CallNotificationButton, { disabled: disabled, variant: "primary", background: theme.colors.red50, backgroundActiveColor: theme.colors.red60, onClick: handleDecline, style: { marginRight: '3.125rem' }, children: [_jsx("span", { style: {
                            transform: 'rotate(135deg)',
                            marginRight: '0.5rem',
                            height: '1.563rem',
                            width: '1.563rem',
                        }, children: _jsx(AppIcon, { name: "PhoneIconPlain", color: theme.colors.white }) }), "Decline"] }), _jsxs(CallNotificationButton, { disabled: disabled, variant: "primary", onClick: handleAnswer, background: theme.colors.green50, backgroundActiveColor: theme.colors.green60, children: [_jsx("span", { style: { marginRight: '0.5rem', height: '1.563rem', width: '1.563rem' }, children: _jsx(AppIcon, { name: "PhoneIconCalling", color: theme.colors.white }) }), "Answer"] })] }));
};
const CallNotificationCard = styled(Card)(({ state }) => {
    return {
        position: 'absolute',
        bottom: '1rem',
        left: '1rem',
        right: '1rem',
        padding: '1rem',
        transition: `transform 200ms ease`,
        ...transitionStyles[state],
    };
});
const CallNotificationButton = styled(Button)(({ background, backgroundActiveColor }) => {
    return {
        '&&&:active': {
            backgroundColor: backgroundActiveColor,
        },
        minWidth: '165px',
        alignItems: 'center',
        backgroundColor: background,
        color: theme.colors.white,
    };
});
export const IncomingCallNotification = memo(_IncomingCallNotification);
//# sourceMappingURL=incoming_call_notification.js.map